export default {
  getShipToStore (state) {
    return state.shipToStore
  },
  getShipToStoreId (state) {
    let id = state.shipStoreId
    id = id.split('-')
    return id[id.length - 1]
  },
  getActiveShippingMethods (state) {
    let getAllShipments = state.shippingMethods
    let activeShipment = state.shippingMethod
    if (getAllShipments && activeShipment) {
      return getAllShipments.filter((ship) => ship.method_code === activeShipment)
    } else {
      return []
    }
  },
  hasBillingAddress (state) {
    let billing = state.billingAddress
    if (billing && Object.keys(billing).length) {
      return true
    } else {
      return false
    }
  },
  hasShippingAddress (state) {
    let shipping = state.shippingAddress
    if (shipping && Object.keys(shipping).length) {
      return true
    } else {
      return false
    }
  },
  hasShippingMethod (state) {
    return state.shippingMethod !== null
  }
}
